<template>
    <div id="map"></div>
</template>

<script setup>
import { reactive, onMounted, onUnmounted } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader"; // 引入高德地图API

const mapList = reactive([{ lng: 106.219941, lat: 38.441096, name: "宁夏回族自治区银川市金凤区宁安大街490号" }]);

// 地图相关
let map = null;
let markers = [];  // 用于存储创建的所有标记


const updateMarkerPosition = () => {
    const screenWidth = window.innerWidth;  // 获取当前设备的宽度
    const labelWidth = 550;
    const offsetX = screenWidth > 768 ? -150 : (screenWidth - labelWidth) / 2;  // 计算移动端居中偏移
    const offsetY = -30;  // 竖直方向偏移量

    // 清除之前的标记
    markers.forEach((marker) => {
        marker.setMap(null);
    });
    markers = [];  // 清空标记数组

    // 添加新的标记
    mapList.forEach((item) => {
        const marker = new AMap.Marker({
            position: new AMap.LngLat(item.lng, item.lat), // 设置标记的位置
        });

        marker.setLabel({
            offset: new AMap.Pixel(offsetX, offsetY),  // 动态调整偏移量
            content: "<div class='label'>宁夏回族自治区银川市金凤区宁安大街490号</div>"
        });

        marker.setMap(map); // 将标记添加到地图中
        markers.push(marker);  // 保存标记
    });
};

// 初始化高德地图
const initMap = () => {
    AMapLoader.load({
        key: "9c7cbd4c31a95a1b0c9d5029ff51fe24",
        version: "2.0",
        plugins: ["AMap.ToolBar", "AMap.Scale", "AMap.Panorama"], // 这里可以加入需要的插件
    }).then((AMap) => {
        // 创建地图实例
        map = new AMap.Map("map", {
            zoom: 12, // 缩放级别
            center: [106.219941, 38.441096], // 初始地图中心点
            viewMode: "3D", // 3D地图模式
        });

        updateMarkerPosition(); // 初始化标记
    }).catch((error) => {
        console.error("加载地图失败:", error);
    });
};

onMounted(() => {
    initMap(); // 加载高德地图
    // 如果屏幕尺寸发生变化，重新计算偏移量
    window.addEventListener('resize', updateMarkerPosition);
});

onUnmounted(() => {
    map?.destroy();  // 销毁地图实例
    // 清理事件监听器
    window.removeEventListener('resize', updateMarkerPosition);
});
</script>

<style scoped>
#map {
    height: 100%;
    width: 100%;
    position: relative;
}

/deep/.amap-marker-label{
    border: 1px solid #dcdfe6 !important;
    font-size: calc(16 * var(--groot-ui-rpx)) !important;
    color: #2c3e50;
    line-height: unset !important;
}
</style>
